import { useCustom, useTranslate } from "@refinedev/core";
import { Button, FormCard, SectionHeader } from "@fawkes/ui";

import { EntityAdmin } from "./EntityAdmin";
import type { EntityCatalogItem } from "./descriptor";

// Entity-admin migration (Jmix-exit): the off-menu, URL-reachable host for the generic docasoft-CRUD
// screens (the migrated `view/docasoft/**` backlog). These generated screens were never in the curated
// Jmix sidebar, so — like `wassen-soorten`/`tags` — they are reached by deep-link rather than a NAV
// entry: `/entity-admin` shows the catalog of migrated entities, `/entity-admin/{key}` opens one.
// A dedicated "Data/Beheer" sidebar hub is a separate product decision, kept out of the locked nav.

function EntityAdminCatalog() {
  const t = useTranslate();
  const { data, isLoading, isError } = useCustom<EntityCatalogItem[]>({
    url: "entity-admin/_catalog",
    method: "get",
  });
  const items = data?.data ?? [];

  if (isLoading) return <p className="fawkes-muted">{t("common.loading")}</p>;
  if (isError) return <p className="fawkes-error">{t("entityAdmin.loadFailed")}</p>;

  return (
    <FormCard>
      <SectionHeader>{t("entityAdmin.catalogTitle")}</SectionHeader>
      {items.length === 0 ? (
        <p className="fawkes-muted">{t("entityAdmin.empty")}</p>
      ) : (
        <div className="fawkes-entityadmin__catalog">
          {items.map((it) => (
            <Button
              key={it.key}
              variant="secondary"
              onClick={() => { globalThis.location.href = `/entity-admin/${encodeURIComponent(it.key)}`; }}
            >
              {it.label}
            </Button>
          ))}
        </div>
      )}
    </FormCard>
  );
}

/** Reads the entity key from `/entity-admin/{key}`; with none, shows the catalog. */
export function EntityAdminHub() {
  const path = globalThis.location?.pathname ?? "";
  const match = /\/entity-admin\/([^/?#]+)/.exec(path);
  const entity = match ? decodeURIComponent(match[1]) : null;
  return entity ? <EntityAdmin entity={entity} /> : <EntityAdminCatalog />;
}
